<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-multiple exCollection="flyExCollection" @ready="onReady" @error="onError" @saved="onSaved"
          @savedNext="onSavedNext" @loadedEx="onLoadedEx" :shared="false" :doc="doc" :pid="true" :synced="false"
          :saveState="saveState">
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step color="amber" :complete="false" step="1">Select Plane</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step color="amber" :complete="false" step="2">Check in</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2>Pick a plane</h2>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- Content goes here   -->
                    <v-col cols="12">
                      <FlySelection :selected-plane="doc.selectedPlane" @updated="setPlane" />
                    </v-col>
                  </v-row>

                  <bottom-navigation :save="true" :next="true" :prev="false" @save="saveExercise(true)" @prev="prevStep"
                    @next="nextStep">
                  </bottom-navigation>
                </v-stepper-content>
                <!-- Step 2 -->
                <v-stepper-content step="2">
                  <!-- Content goes here   -->
                  <FlyTicket v-if="doc.selectedPlane && doc.selectedPlane.id" :selected-plane="livePlane"
                    :doc="doc.ticket" @doAutoSave="doAutoSave" />
                  <div v-else>
                    <p>Please select a plane</p>
                  </div>

                  <bottom-navigation :save="true" :next="false" :prev="true" @save="saveExercise(true)" @prev="prevStep"
                    @next="nextStep">
                  </bottom-navigation>
                </v-stepper-content>
                <!-- Step 3 -->
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("exercise_functionality.saved.title")
        }}</v-card-title>

        <v-card-text>{{
          $t("exercise_functionality.saved.description")
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="amber accent-1" text :to="`/users/project/${$route.params.id}`">
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";
import { FlyTicket, FlySelection } from "@/views/user/exercises/fly";

export default {
  name: "UserBrandTilesBeta",
  data() {
    return {
      e1: 1,
      content: null,
      saveState: false,
      autoSave: true,
      dialog: false,
      doc: {
        selectedPlane: null,
        ticket: {
          checkin: "",
          ticket: "",
          classes: "",
          passengers: "",
          destinations: "",
          entertainment: "",
          music: "",
          catering: "",
          crew: "",
          ambience: "",
        },
      },
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    FlyTicket,
    FlySelection,
  },
  watch: {},
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
      "currentPlanes",
    ]),
    livePlane() {
      const saved = this.doc.selectedPlane;
      if (!saved || !saved.id) return saved;
      const canon = (this.currentPlanes || []).find((p) => p && p.id === saved.id);
      return canon ? { ...saved, ...canon } : saved;
    },
  },

  mounted() { },

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() { },
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedRef(refs) {
      console.log("loaded refs", refs);
      this.allTiles = refs;
    },
    onLoadedEx(items) {
      if (!items || !items[0] || !items[0].doc) return;
      const saved = items[0].doc;
      this.doc = {
        ...this.doc,
        ...saved,
        ticket: { ...this.doc.ticket, ...(saved.ticket || {}) },
      };
    },
    onModifyEx(items) {
      this.exercises = [...items];
    },
    onSavedNext() {
      this.saveState = false;
    },

    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },
    setPlane(item) {
      this.$set(this.doc, "selectedPlane", item);
      this.doAutoSave();
    },
  },
};
</script>

<style lang="scss"></style>
